/**
 * 为了兼容map文件方式
 * @param event
 * @param params
 */
export default function fixEventParams(event: any, params: any) {
  const eventInfo = {};
  if (typeof event === 'object') {
    // 兼容埋点map文件
    Object.assign(eventInfo, event, params);
  } else {
    Object.assign(eventInfo, { event }, params);
  }

  return eventInfo;
}
